export const SFWTranslations = {
  de: {
    shopFloorWalk: "Shop Floor Walk",
    sfwAssets: "Montageboxen",
    walkThrough: "Walk-through",
    startProcess: "Prozess starten",
    noProcessStarted: "Kein gestarteter Prozess",
    mechanik: "Mechanik",
    elektrik: "Elektrik",
    general: "Allgemein",
    editTicketData: "Daten bearbeiten",
    finishProcess: "Vorgang Abschließen",
    processStarted: "Prozess gestartet",
    startProcessDialogTitle: "Prozess starten",

    finishProcessConfirmTitle: "Vorgang abschließen",
    finishProcessConfirmMessage:
      "Möchten Sie den Vorgang wirklich abschließen?",
    processFinished: "Vorgang abgeschlossen",
    walkThroughView: "Walk-through",
    more: "Mehr",
    noAssets: "Keine Anlagen gefunden",
    sfwWalkHistory: "Walk-through Historie",
    sfwWalkthroughStatus: "Walk-through Status",
    sfwWalkthroughStatusDescription: "Status des Walk-throughs",
    templateNotFound: "Schablone nicht gefunden",
  },
  en: {
    shopFloorWalk: "Shop Floor Walk",
    sfwAssets: "Assembly Boxes",
    walkThrough: "Walk-through",
    startProcess: "Start process",
    noProcessStarted: "No process started",
    mechanik: "Mechanics",
    elektrik: "Electrics",
    general: "General",
    editTicketData: "Edit data",
    processStarted: "Process started",
    startProcessDialogTitle: "Start Process",
    finishProcess: "Finish Process",
    finishProcessConfirmTitle: "Finish process",
    finishProcessConfirmMessage:
      "Are you sure you want to finish this process?",
    processFinished: "Process finished",
    walkThroughView: "Walk-through",
    more: "More",
    noAssets: "No assets found",
    sfwWalkthroughStatus: "Walk-through Status",
    sfwWalkthroughStatusDescription: "Walk-through status",
    sfwWalkHistory: "Walk-through History",
    templateNotFound: "Template not found",
  },
};
